import Alert from "shared/components/utils/icons/Alert";
import Button from "shared/components/inputs/mui/Button";
import PropTypes from "prop-types";
import moment from "moment";
import { useEmailError } from "shared/hooks/errors/useEmailError";
import { useState } from "react";
import { useTestConnection } from "shared/hooks/useTestConnection";
import {
    Icon,
    Content,
    ErrorDetail,
    Header,
    Body,
    Footer,
    Wrapper,
    ReloadButton,
    ShowDetailsButton,
    RawErrorContainer,
} from "./ErrorModal.styles";

const DEFAULT_ERROR = {
    detail: {
        title: "Something Went Wrong",
        message: "Sorry, we couldn't process your request because of an error.",
        actionMessage:
            " Please check your URL, or reload the page to start again.",
    },
    status: undefined,
    date: undefined,
    correlationId: undefined,
    action: undefined,
    errorPageURL: undefined,
    reloadPageURL: globalThis.config.routes.root,
    rawError: undefined,
    showDetail: false,
};

const ErrorModal = (props) => {
    const { error, popup } = props;

    const {
        title,
        subTitle,
        message,
        actionMessage,
        rawError,
        status,
        correlationId,
        action,
        reloadPageURL,
        detail,
    } = error ?? DEFAULT_ERROR;

    const errorTitle = title || "Something Went Wrong";
    const errorSubTitle = subTitle || "";
    const errorMessage = message || "Sorry, we couldn't process your request because of an error.";
    const errorActionMessage = actionMessage || "Contact support team.";

    const { sendEmail } = useEmailError();
    const { testConnection } = useTestConnection();
    const [showRawError, setShowRawError] = useState(false);

    const handleclick = () => {
        sendEmail(rawError);
    };

    const handleTestConnection = async () => {
        const rv = await testConnection();
        alert(rv);
    };

    const reloadPage = (url) => {
        action?.();
        globalThis.location.assign(url);
    };

    return (
        <Wrapper popup={popup}>
            {popup}
            <Icon>
                <Alert size="25" viewBox="18" />
            </Icon>
            <Header>{errorTitle}</Header>
            <Body>
                <Content>
                    {errorSubTitle && (
                        <p>
                            <b>{errorSubTitle}</b>
                        </p>
                    )}
                    <p>{errorMessage}</p>
                    {detail && <p>{detail}</p>}
                    <br />
                    {rawError && (
                        <>
                            <ShowDetailsButton onClick={() => setShowRawError(!showRawError)}>
                                {showRawError ? "Hide Details" : "Show Details"}
                            </ShowDetailsButton>
                            {showRawError && (
                                <RawErrorContainer>
                                    {detail} -
                                    {typeof rawError === 'string' ? rawError : JSON.stringify(rawError, null, 2)}
                                </RawErrorContainer>
                            )}
                        </>
                    )}
                    <br />
                    <br />
                    {errorActionMessage && (
                        <>
                            <p>{errorActionMessage}</p>
                            <br />
                        </>
                    )}
                    <ErrorDetail>
                        <p>
                            Date:{" "}
                            {moment().format("MMMM Do YYYY, h:mm:ss a")}
                        </p>
                        <p>
                            Date (UTC):{" "}
                            {moment().utc().format("MMMM Do YYYY, h:mm:ss a")}
                        </p>
                        <p>Error code: {status ?? "Unknown"}</p>
                        <p>Correlation ID: {correlationId ?? "Unknown"}</p>
                    </ErrorDetail>
                </Content>
            </Body>
            <Footer>
                <Button style={{ width: "11.75rem" }} onClick={handleclick}>
                    Email Support
                </Button>
                {!popup && (
                    <ReloadButton onClick={() => reloadPage(reloadPageURL)}>
                        Reload Page
                    </ReloadButton>
                )}
                <Button style={{ width: "11.75rem" }} onClick={handleTestConnection}>
                    Test Connection
                </Button>
            </Footer>
        </Wrapper>
    );
};

ErrorModal.propTypes = {
    error: PropTypes.object,
    popup: PropTypes.bool,
};

export default ErrorModal;
